(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-content-pdp"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('details.product-content-pdp').forEach((detailsEl) => {
      const readMore = detailsEl.querySelector('.product-content-pdp-read');
      const content = detailsEl.querySelector('.detail-expand');
      if (!readMore || !content) return;

      // Count words in the content
      const wordCount = content.textContent.trim().split(/\s+/).length;

      const isSmallScreen = window.innerWidth <= 768; // adjust breakpoint
      const limit = isSmallScreen ? 80 : 160;

      if (wordCount <= limit) {
        // Hide the toggle if content is short
        readMore.style.display = 'none';
        // Force expanded state
        detailsEl.classList.add('expanded');
        return;
      }

      if (readMore) {
        // Click handler: toggle class & update label
        readMore.addEventListener('click', () => {
          detailsEl.classList.toggle('expanded');
          if (detailsEl.classList.contains('expanded')) {
            readMore.textContent = 'Read less';
          } else {
            readMore.textContent = 'Read more';
          }
        });
      }
    });
  });

document.addEventListener('DOMContentLoaded', function () {

  function initVideoLoop(container) {
    const mainVideo = container.querySelector('.main-video video');
    const thumbnails = Array.from(container.querySelectorAll('.thumbnails .thumb video'));

    if (!mainVideo || thumbnails.length === 0) return;

    // Required for autoplay stability
    mainVideo.muted = true;
    thumbnails.forEach(v => v.muted = true);

    function stopThumbnails() {
      thumbnails.forEach(v => {
        v.pause();
        v.currentTime = 0;
      });
    }

    function playMain() {
      stopThumbnails();

      mainVideo.pause();
      mainVideo.currentTime = 0;
      mainVideo.load();              // IMPORTANT
      mainVideo.play().catch(() => {});
    }

    function playThumb(index) {
      stopThumbnails();

      const v = thumbnails[index];
      v.pause();
      v.currentTime = 0;
      v.load();                      // IMPORTANT
      v.play().catch(() => {});
    }

    // Main → first thumbnail
    mainVideo.addEventListener('ended', () => {
      playThumb(0);
    });

    // Thumbnails → next or main
    thumbnails.forEach((video, index) => {
      video.addEventListener('ended', () => {
        if (index + 1 < thumbnails.length) {
          playThumb(index + 1);
        } else {
          playMain();
        }
      });
    });

    // Start loop
    playMain();
  }

  // Init DESKTOP and MOBILE separately
  const desktopContainer = document.querySelector('.product-detail-tab-desktop');
  const mobileContainer = document.querySelector('.product-detail-tab-mobile');

  if (desktopContainer) initVideoLoop(desktopContainer);
  if (mobileContainer) initVideoLoop(mobileContainer);

});
  } catch(e) { console.error(e); }
})();

})();
